import React, { FC } from "react";
import { Outlet } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FilterContextProvider } from "./context/filter-context/FilterContext";
import { NotificationContextProvider } from "./context/notification/NotificationContext";
import Notification from "./components/notification/Notification";
import { Tooltip } from "react-tooltip";
import Event from "./components/notification/Event";
import TailwindCssSafeList from "./devtools/TailwindCssSafeList";
import { ThemeContextProvider } from "./context/theme/ThemeContext";

const queryClient = new QueryClient();

const App: FC = () => {
    return (
        <>
            <QueryClientProvider client={queryClient}>
                <NotificationContextProvider>
                    <FilterContextProvider>
                        <ThemeContextProvider>
                            <Outlet />
                            <Notification />
                            <Event />
                            <Tooltip id="global-tooltip" style={{ zIndex: 9999 }} />
                        </ThemeContextProvider>
                    </FilterContextProvider>
                </NotificationContextProvider>
            </QueryClientProvider>
            <TailwindCssSafeList />
        </>
    );
};

export default App;

